<div [ngClass]="_styleClasses">
    <ng-content></ng-content>
</div>
